export default __webpack_public_path__ + "static/media/koala@3x.4be5f25d.png";